import script from "./UpcomingBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpcomingBar.vue?vue&type=script&setup=true&lang=ts"

import "./UpcomingBar.vue?vue&type=style&index=0&id=08abd1ea&lang=css"

const __exports__ = script;

export default __exports__